import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={26.64}
    height={32}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-1{fill:none;stroke:#00a4b7;stroke-miterlimit:10;stroke-width:2px}"
        }
      </style>
    </defs>
    <g id="Palette">
      <path d="M14.98.71 9.32 6.36l5.66 5.66" className="cls-1" />
      <path
        d="M4.61 9.97A12.282 12.282 0 0 0 1 18.68C1 25.48 6.52 31 13.32 31s12.32-5.52 12.32-12.32S20.12 6.36 13.32 6.36h-4"
        className="cls-1"
      />
    </g>
  </svg>
)
export default SvgComponent
